var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8TrinidadAndTobago(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff1744",
    d: "M4,24c0,11.046,8.954,20,20,20c2.82,0,5.5-0.59,7.932-1.643L5.839,15.659C4.67,18.201,4,21.019,4,24 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff1744",
    d: "M24,4c-2.82,0-5.5,0.59-7.932,1.643l26.093,26.698C43.33,29.799,44,26.981,44,24 C44,12.954,35.046,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M5.839,15.659l26.093,26.698c0.894-0.387,1.746-0.85,2.567-1.358L7.24,13.108 C6.711,13.919,6.247,14.773,5.839,15.659z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M13.501,7.001l27.26,27.891c0.528-0.811,0.992-1.665,1.4-2.552L16.068,5.643 C15.173,6.03,14.322,6.492,13.501,7.001z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M7.24,13.108l27.26,27.892c2.51-1.554,4.652-3.636,6.261-6.107L13.501,7.001 C10.991,8.554,8.849,10.637,7.24,13.108z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TrinidadAndTobago);
export default __webpack_public_path__ + "static/media/icons8-trinidad-and-tobago.e5effe15804648e10ddc3017fed24b80.svg";
export { ForwardRef as ReactComponent };